// Audio samples for the public welcome page's Sound Room.
// Empty until the owner supplies samples. Each entry:
// { slug, title, category, description, src } where src is a file under public/audio/.
export const AUDIO_SHOWCASE = [];
